<template>
  <div :id="pickerId" data-test="timezone-picker"></div>
</template>

<script>
export default {
  name: 'timezone-picker',
  props: {
    timezone: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pickerId: `timezone-picker-${Math.random()
        .toString(36)
        .slice(2)}`,
    };
  },
  mounted() {
    $(`#${this.pickerId}`).timezonePicker({
      defaultValue: this.timezone || moment.tz.guess(),
      filterBoxClass: 'timezone-picker-panel',
      hoverTextClass: 'timezone-picker-text',
      quickLink: [
        {
          Pacific: 'America/Los_Angeles',
          Mountain: 'America/Denver',
          Central: 'America/Chicago',
          Eastern: 'America/New_York',
        },
      ],
      quickLinkClass: 'timezone-picker-buttons',
      selectClass: 'timezone-picker-select',
    });

    $(`#${this.pickerId}`).on('map:country:clicked', () => this.selectTimezone());
    $(`#${this.pickerId}`).on('map:quickLink:clicked', () => this.selectTimezone());
    $(`#${this.pickerId}`).on('map:option:changed', () => this.selectTimezone());
  },
  watch: {
    timezone(value) {
      $(`#${this.pickerId}`)
        .data('timezonePicker')
        .setValue(value || moment.tz.guess());
    },
  },
  methods: {
    selectTimezone() {
      const [result] = $(`#${this.pickerId}`)
        .data('timezonePicker')
        .getValue();
      this.$emit('timezone-select', result.timezone);
    },
  },
};
</script>

<style lang="scss">
.timezone-picker-panel {
  display: flex;
  flex-wrap: wrap;
}

.timezone-picker-buttons {
  display: flex;
}

.timezone-picker-buttons > span {
  background-color: #333333;
  border-color: #333333;
  border-radius: 5px;
  color: #ffffff;
  cursor: pointer;
  margin-left: 10px;
  padding: 2px 10px;
}

.timezone-picker-buttons > span:hover {
  background-color: #1a1a1a;
  border-color: #1a1a1a;
}

.timezone-picker-text {
  margin-left: 10px;
}

.timezone-picker-text p {
  margin: 0;
}
</style>
